export function formatLargeNumber(amount: number): string {

  const isNegative = amount < 0;
  const absAmount = Math.abs(amount);

  const units = [
    { value: 1000000000000, suffix: " T" },
    { value: 1000000000, suffix: " Bn" },
    { value: 1000000, suffix: " M" },
    { value: 1000, suffix: " K" },
  ];

  for (const unit of units) {
    if (absAmount >= unit.value) {
      const formatted = (absAmount / unit.value).toFixed(2); 
      const sign = isNegative ? "-" : "";
      return formatted.endsWith(".00") ? sign + Math.round(absAmount / unit.value) + unit.suffix : sign + formatted + unit.suffix;
    }
  }

  return amount.toString(); 
}
